<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="id">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#' + id_c" aria-expanded="false" :aria-controls="id_c">
        {{ capitalizeFirstChar(title) }}
      </button>
    </h2>
    <div :id="id_c" class="accordion-collapse collapse" :aria-labelledby="id" :data-bs-parent="'#' + parentId">
      <div class="accordion-body" style="text-align: justify"  v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemPart",
  props: {
    title: String,
    content: String,
    parentId: String
  },
  data: function (){
    return {
      id: null,
      id_c: null,
    }
  },
  methods: {
    capitalizeFirstChar(text) {
      if (!text) return '';
      const locale = this.$i18n?.locale === 'cz' ? 'cs-CZ' : 'sk-SK';
      return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
    }
  },
  created() {
    this.id = 'ac_' + Math.round(Math.random() * 100000);
    this.id_c = this.id + '1';
  }
}
</script>

<style scoped>

</style>